const dwellingTypes = [
  { id: "-1", name: "Please select improvement type" },
  { id: "7", name: "Ancillary buildings/sheds" },
  { id: "4", name: "Apartment" },
  { id: "2", name: "Attached dwelling" },
  { id: "1", name: "Detached dwelling" },
  { id: "8", name: "Education facility" },
  { id: "9", name: "Factory" },
  { id: "10", name: "Farm (dwelling)" },
  { id: "11", name: "Grain store" },
  { id: "12", name: "Hardstand" },
  { id: "13", name: "Livestock sheds" },
  { id: "14", name: "Medical centre" },
  { id: "15", name: "Retail shop" },
  { id: "16", name: "Store" },
  { id: "5", name: "Townhouse" },
  { id: "6", name: "Vacant land" },
  { id: "3", name: "Villa unit" },
  { id: "17", name: "Warehouse" },
  { id: "18", name: "Other" },
];

export default dwellingTypes;
